export type Lang = 'gr' | 'en';

/** The store name in the guest's language: the optional English name when reading in English. */
export const displayName = (b: { name: string; nameEn?: string }, lang: Lang): string =>
  (lang === 'en' && b.nameEn?.trim()) || b.name;

/** A link that keeps the guest's language across the full page load to another store. */
export const withLang = (path: string, lang: Lang): string => (lang === 'en' ? `${path}?lang=en` : path);

/** `?lang=en` on arrival (a picker link or a shared English link) starts the menu in English. */
export const initialLang = (search: string = typeof window === 'undefined' ? '' : window.location.search): Lang =>
  new URLSearchParams(search).get('lang') === 'en' ? 'en' : 'gr';
